<template>
  <transition>
    <div
      v-if="filterToggle"
      class="pt-2"
    >
      <b-form
        class="border-dashed"
      >
        <b-row>
          <!--SKU-->
          <b-col md="4">
            <b-form-group
              :label="$t(filterClass.getLabel(Period.YEAR))"
            >
              <b-form-input
                v-model="filters[Period.YEAR]"
                :placeholder="filterClass.getLabel(Period.YEAR)"
              />
            </b-form-group>
          </b-col>
          <!--Brand-->
          <!--Categories-->
          <b-col md="4">
            <b-form-group
              :label="filterClass.getLabel(Period.STATUS)"
            >
              <v-select
                :id="Period.STATUS"
                v-model="filters[Period.STATUS]"
                :reduce="(option) => option.value"
                :options="options"
                label="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button
              variant="success"
              @click="onFilter"
            >
              <feather-icon icon="LFilterIcon" />
              {{ $t('Filter') }}
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </div>
    <div v-else />
  </transition>
</template>

<script>
import {
  BForm, BButton, BRow, BCol,
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import vSelect from 'vue-select'
import Period from '@/views/components/filters/service/Period'

export default {
  name: 'CustomersFilterComponent',
  components: {
    vSelect,
    BForm,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
  },
  props: {
    filterToggle: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: [Array, Object],
      default: () => ({}),
    },
    filterClass: {
      type: [Object, null],
      default: null,
    },
    selectedFilters: {
      type: [Array],
      default: () => ([]),
    },
  },
  data() {
    return {
      filterCustomer: {},
    }
  },
  computed: {
    Period() {
      return Period
    },
    options: {
      get() {
        return [
          { value: 1, text: this.$t('Active') },
          { value: 0, text: this.$t('Not Active') },
        ]
      },
    },
  },
  methods: {
    onFilter() {
      this.$emit('onFilter', this.filter)
    },
    removeSelectedFilter(path) {
      this.filterClass.removeSelectedFilter(this.filters, path)
      this.$emit('onRemoveSelectedFilter', path)
    },
    removeSearchFilter() {
      this.$emit('searchQueryClear')
    },
  },
  setup() {
    return {
    }
  },
}
</script>

<style scoped>

</style>
